const steps = [
  "Order Request",
  "Get Quotes",
  "Place Order",
  "Quality Check",
  "Delivery",
];

export default function Steps() {
  return (
    <div className="hidden lg:flex justify-center">
      <div className="flex items-center">
        {steps.map((step, index) => (
          <div key={index} className="flex items-center">
            <div className="flex flex-col items-center w-full">
              <div className="size-8 rounded-full border border-gray-600 text-gray-600 flex items-center justify-center text-sm font-semibold">
                {index + 1}
              </div>
              <p className="text-xs mt-2 text-center text-[#475467]">{step}</p>
            </div>

            {index !== steps.length - 1 && (
              <div className="w-20 h-[2px] bg-gray-200 mx-2" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
